<script setup lang="ts">
  import { ref, watch } from 'vue'
  import { Select, SelectOption } from 'ant-design-vue'
  import { useWindowSize } from '@/composables/useWindowSize'

  interface IArrayValuesPlotConfigurationProps {
    modelValue: string[]
    placeHolder: string
  }
  const { controlSize } = useWindowSize()
  const props = defineProps<IArrayValuesPlotConfigurationProps>()
  const emit = defineEmits<{ 'update:modelValue': [value: string[]] }>()

  const values = ref<string[]>([...props.modelValue])

  watch(
    () => props.modelValue,
    (newVal) => {
      values.value.splice(0, values.value.length, ...newVal)
    },
    { deep: true }
  )

  watch(
    values,
    (newVal) => {
      emit('update:modelValue', [...newVal])
    },
    { deep: true }
  )
</script>

<template>
  <div class="array-values-plot-config">
    <Select
      v-model:value="values"
      mode="tags"
      :open="false"
      :placeholder="placeHolder"
      :size="controlSize"
      class="w-full"
      showSearch
      allowClear
    >
      <SelectOption v-for="value in values" :key="value" :value="value">
        {{ value }}
      </SelectOption>
    </Select>
  </div>
</template>

<style scoped>
  .array-values-plot-config {
    display: flex;
    flex-direction: column;
  }
  .tag {
    margin-bottom: 4px;
  }
</style>
